// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {FormControl, Validators} from "@angular/forms";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_CreateEditByNameDialogInput extends MatDialogDataBaseInput {
	title: string;
	preValue: string;
}

export interface DialogData_CreateEditByNameDialogOutput extends MatDialogDataBaseOutput {
	newName: string;
}

@Component({
	selector: "sim-create-edit-by-name-dialog",
	templateUrl: "./create-edit-by-name-dialog.component.html",
	standalone: false,
})
export class CreateEditByNameDialogComponent
	extends BasicMaterialDialog<
		CreateEditByNameDialogComponent,
		DialogData_CreateEditByNameDialogInput,
		DialogData_CreateEditByNameDialogOutput
	>
	implements OnInit
{
	formCtrl = new FormControl("", [Validators.required]);

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {
		if (this.data.preValue !== null) {
			this.formCtrl.setValue(this.data.preValue);
		}
	}

	public createNewItem(): void {
		this.close({
			action: "ok",
			newName: this.formCtrl.value,
		});
	}
}
